import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47d20322&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=47d20322&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d20322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/panzhijing/蛋卷科技/danjuan-admin/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d20322')) {
      api.createRecord('47d20322', component.options)
    } else {
      api.reload('47d20322', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47d20322&scoped=true", function () {
      api.rerender('47d20322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/currentCall/defaultItem/index.vue"
export default component.exports